<template>
  <a-modal
    :visible="visible"
    :title="title || 'Create Payable Pay Code' + (isBatch ? 's' : '') + ' Without Enough Balance?'"
    :confirm-loading="loading"
    :ok-text="actionLabel"
    :ok-button-props="{ props: { disabled: !reason.trim() } }"
    cancel-text="Go Back"
    width="820px"
    data-testid="shift-pay-code-accrual-confirmation"
    @cancel="$emit('back')"
    @ok="confirm"
  >
    <p v-if="stale" class="accrual-stale" data-testid="shift-pay-code-accrual-stale">
      Paid-time balances changed. Review the updated amounts before creating Pay Codes.
    </p>
    <p v-if="isBatch">
      {{ affectedAssociateCount }} of {{ totalAssociates }} associates have paid hours that are not covered by their
      balance.
    </p>
    <a-table :columns="columns" :data-source="rows" :pagination="false" :row-key="row => row.key" size="small">
      <span slot="associate" slot-scope="text, row">{{ row.associate }}</span>
      <span slot="requested" slot-scope="text, row">{{ formatHours(row.quote.requested) }}</span>
      <span slot="available" slot-scope="text, row">{{ formatHours(row.quote.balance?.available) }}</span>
      <span slot="covered" slot-scope="text, row">{{ formatHours(row.quote.covered) }}</span>
      <span slot="outside" slot-scope="text, row"
        ><strong>{{ formatHours(row.quote.outside) }}</strong></span
      >
      <span slot="after" slot-scope="text, row">{{ formatHours(row.quote.balance_after?.available) }}</span>
    </a-table>
    <a-form-model-item label="Reason for paying outside the balance" required class="reason-field">
      <a-textarea v-model="reason" :rows="2" placeholder="Required" data-testid="shift-pay-code-accrual-reason" />
    </a-form-model-item>
  </a-modal>
</template>

<script>
import { FormModel, Input, Modal, Table } from 'ant-design-vue'

export default {
  components: {
    'a-modal': Modal,
    'a-table': Table,
    'a-form-model-item': FormModel.Item,
    'a-textarea': Input.TextArea
  },
  props: {
    visible: { type: Boolean, default: false },
    rows: { type: Array, default: () => [] },
    totalAssociates: { type: Number, default: 1 },
    isBatch: { type: Boolean, default: false },
    actionLabel: { type: String, required: true },
    title: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    stale: { type: Boolean, default: false }
  },
  data() {
    return {
      reason: '',
      columns: [
        { title: 'Associate', key: 'associate', scopedSlots: { customRender: 'associate' } },
        { title: 'Payable', key: 'requested', scopedSlots: { customRender: 'requested' } },
        { title: 'Available', key: 'available', scopedSlots: { customRender: 'available' } },
        { title: 'Covered', key: 'covered', scopedSlots: { customRender: 'covered' } },
        { title: 'Outside Balance', key: 'outside', scopedSlots: { customRender: 'outside' } },
        { title: 'Balance After', key: 'after', scopedSlots: { customRender: 'after' } }
      ]
    }
  },
  computed: {
    affectedAssociateCount() {
      return new Set(this.rows.map(row => row.associate_id)).size
    }
  },
  watch: {
    visible(value) {
      if (!value) this.reason = ''
    }
  },
  methods: {
    formatHours(value) {
      return value === null || value === undefined ? '-' : `${value}h`
    },
    confirm() {
      if (this.reason.trim()) this.$emit('confirm', this.reason.trim())
    }
  }
}
</script>

<style scoped>
.accrual-stale {
  color: #873800;
}

.reason-field {
  margin-top: 16px;
}
</style>
